import { render, staticRenderFns } from "./popupDrawer.vue?vue&type=template&id=25c84e04&scoped=true&"
import script from "./popupDrawer.vue?vue&type=script&lang=js&"
export * from "./popupDrawer.vue?vue&type=script&lang=js&"
import style0 from "./popupDrawer.vue?vue&type=style&index=0&id=25c84e04&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25c84e04",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemIcon } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VNavigationDrawer } from 'vuetify/lib/components/VNavigationDrawer';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer,VDivider,VIcon,VListItem,VListItemContent,VListItemIcon,VListItemTitle,VNavigationDrawer,VRow})
